import { ClientJS } from 'clientjs';
import { StorageParams } from '../../../constants/StorageParams';

export class UserFingerprint {
    private firstWebVisitTs: number;
    private firstWebVisitRnd: string;
    private fingerPrintId: number;
    private clientJs: ClientJS;

    constructor(clientJs: ClientJS) {
        console.log('Fingerprint user start');
        this.clientJs = clientJs;
        this.firstWebVisitRnd = this.getRnd();
        this.firstWebVisitTs = this.getTs();
        this.fingerPrintId = this.getId();
    }

    public getTs(): number {
        const localFirstWebVisitTs = localStorage.getItem(StorageParams.FIRST_WEB_VISIT_TS);
        const cookieFirstWebVisitTs = $.cookie(StorageParams.FIRST_WEB_VISIT_TS);
        const parsedLocalTs = UserFingerprint.parseTs(localFirstWebVisitTs);
        const parsedCookieTs = UserFingerprint.parseTs(cookieFirstWebVisitTs);
        if (parsedLocalTs) {
            this.firstWebVisitTs = parsedLocalTs;
        } else if (parsedCookieTs) {
            this.firstWebVisitTs = parsedCookieTs;
            UserFingerprint.setLocalItem(StorageParams.FIRST_WEB_VISIT_TS, `${parsedCookieTs}`);
        } else {
            const ts = Math.floor(new Date().getTime() / 1000);
            this.firstWebVisitTs = ts;
            UserFingerprint.setLocalItem(StorageParams.FIRST_WEB_VISIT_TS, `${ts}`);
            $.cookie(StorageParams.FIRST_WEB_VISIT_TS, `${ts}`, {
                path: '/'
            });
        }
        return this.firstWebVisitTs;
    }

    public getRnd(): string {
        const localFirstWebVisitRnd = localStorage.getItem(StorageParams.FIRST_WEB_VISIT_RND);
        const cookieFirstWebVisitRnd = $.cookie(StorageParams.FIRST_WEB_VISIT_RND);
        if (!localFirstWebVisitRnd && !cookieFirstWebVisitRnd) {
            const ts = new Date().getTime();
            this.firstWebVisitRnd = `${ts}`;
            UserFingerprint.setLocalItem(StorageParams.FIRST_WEB_VISIT_RND, `${ts}`);
            $.cookie(StorageParams.FIRST_WEB_VISIT_RND, `${ts}`, {
                path: '/'
            });
        } else {
            this.firstWebVisitRnd = (localFirstWebVisitRnd) ? localFirstWebVisitRnd : `${cookieFirstWebVisitRnd}`;
        }
        return this.firstWebVisitRnd;
    }

    public getId(): number {
        this.fingerPrintId = this.clientJs.getFingerprint();
        return this.fingerPrintId;
    }

    private static setLocalItem(key: StorageParams, value: string): void {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error(`Fingerprint: cannot persist ${key}: ${(<Error>error).message}`);
            window.Sentry.captureException(error);
        }
    }

    private static parseTs(value: string | number | null | undefined): number | null {
        const parsed = value ? parseInt(`${value}`, 10) : NaN;

        return (Number.isFinite(parsed) && parsed > 0) ? parsed : null;
    }
}
